import React, { useEffect } from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { sortPurchaseOrder } from "../../../redux/reducer/purchaseOrder/purchaseOrderReducer";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import moment from "moment";
import { sortDebtPlastic } from "../../../redux/reducer/debtPlastic/debtPlasticReducer";
import { sortDebtMoney } from "../../../redux/reducer/debtMoney/debtMoneyReducer";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  getPurchaseOrderFarmerById,
  postPurchaseOrderFarmer,
  purchaseOrderFarmerActions,
} from "../../../redux/reducer/purchaseOrderFarmer/purchaseOrderFarmerReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#f7f7f7",
    borderBottom: "1px solid #fff",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function AdminPurchaseOrderFarmerTambah() {
  // Navigate
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [showedData, setShowedData] = useState({
    farmerDebt: "",
    farmerDebtPlastic: "",
    totalNota: "",
    totalPembayaran: "",
    bonus: "",
    paidFarmerDebt: "",
  });
  const [purchaseOrder, setPurchaseOrder] = useState([]);
  const [searchData, setSearchData] = useState({
    from: "",
    to: "",
    farmerId: "",
  });
  const [selectedPO, setSelectedPO] = useState([]);
  const [debtPlastic, setDebtPlastic] = useState([]);
  const [farmerDebtId, setFarmerDebtId] = useState("");
  const [totalPembayaranNota, setTotalPembayaranNota] = useState("");

  const handleSubmitAll = () => {
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          data: {
            farmerId: searchData.farmerId,
            listPurchaseOrderFarmer: selectedPO,
            listDebtPlasticFarmer: debtPlastic,
            listDebtMoneyFarmer: farmerDebtId,
            paymentDetails: {
              paymentDate: moment().format(),
              totalPayment: totalPembayaranNota,
              debtMoneyInstallmentAmount: showedData.paidFarmerDebt,
            },
            createdBy: user.username,
            updatedBy: user.username,
          },
          token: token,
        };
        dispatch(postPurchaseOrderFarmer(data)).then((res) => {
          if (res.payload.status === 201) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getPurchaseOrderFarmerById(dataGetById)).then((result) => {
              dispatch(
                purchaseOrderFarmerActions.addPurchaseOrderFarmer(
                  result.payload.data
                )
              );
              toast.success(res.payload.message);
              navigate("/admin/keuangan/pembayaran-nota");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const purchaseOrderFarmer = ["#", "KODE", "PETANI", "HARGA", "STATUS"];

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  const setDebtPlasticData = (data, farmerDebt) => {
    setShowedData({
      ...showedData,
      farmerDebt: farmerDebt,
      farmerDebtPlastic: data.reduce(
        (acc, cur) =>
          parseInt(acc) +
          parseInt(cur.quantity * cur.goodsOperationalId.priceOfGoods),
        0
      ),
    });
    const newData = [...data].map((item) => {
      return item._id;
    });
    setDebtPlastic(newData);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const getPO = {
      token: token,
      body: {
        isActive: true,
        status: 1,
        createdAt: {
          $gte: moment(searchData.from).format(),
          $lte: moment(searchData.to)
            .add(23, "hours")
            .add(59, "minutes")
            .format(),
        },
        farmerId: searchData.farmerId,
      },
      params: {
        paginate: false,
      },
    };
    const getDebt = {
      token: token,
      body: {
        isActive: true,
        status: 1,
        farmerId: searchData.farmerId,
      },
    };
    dispatch(sortPurchaseOrder(getPO)).then((res) => {
      setPurchaseOrder([...res.payload.data.docs]);
    });

    dispatch(sortDebtMoney(getDebt)).then((res) => {
      const farmerDebt = res.payload.data.docs[0].debtDetails.remainingAmount;
      setFarmerDebtId(res.payload.data.docs[0]._id);
      if (res) {
        dispatch(sortDebtPlastic(getDebt)).then((result) => {
          setDebtPlasticData(result.payload.data.docs, farmerDebt);
        });
      }
    });
  };

  const handleChangeSearch = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const calculateTotalNota = (data) => {
    const newTotalNota = data.reduce(
      (acc, cur) => parseInt(acc) + parseInt(cur.totalPrices),
      0
    );
    setShowedData({
      ...showedData,
      totalNota: newTotalNota,
      totalPembayaran:
        newTotalNota + showedData.bonus - showedData.farmerDebtPlastic,
    });
    setTotalPembayaranNota(
      newTotalNota + showedData.bonus - showedData.farmerDebtPlastic
    );
  };

  const handleCheckPO = (data) => (e) => {
    if (e.target.checked) {
      const pushedPO = [...selectedPO];
      pushedPO.push(data);
      calculateTotalNota(pushedPO);
      setSelectedPO(pushedPO);
    } else {
      const filteredPO = [...selectedPO].filter(
        (value) => value._id !== data._id
      );
      calculateTotalNota(filteredPO);
      setSelectedPO(filteredPO);
    }
  };

  const handleChangeShowedData = (e) => {
    setShowedData({
      ...showedData,
      [e.target.name]: parseInt(e.target.value),
    });
  };

  useEffect(() => {
    setTotalPembayaranNota(
      showedData.totalPembayaran + showedData.bonus - showedData.paidFarmerDebt
    );
  }, [showedData.bonus, showedData.paidFarmerDebt]);

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          BAYAR NOTA PETANI
        </Typography>
      </Card>
      <form style={{ width: "100%" }} onSubmit={handleSearch}>
        <Card className={styles.headerClass} width="100%">
          <Typography fontSize={14} color={"#0A543B"} style={{ margin: 10 }}>
            Pilih tanggal pembayaran
          </Typography>
          <Box display={"flex"} width="100%">
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Tanggal Mulai"
              name="from"
              size="small"
              type="date"
              onChange={handleChangeSearch}
              variant="outlined"
              style={{ width: "49%", marginBottom: "10px", marginRight: 15 }}
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Tanggal Akhir"
              name="to"
              size="small"
              type="date"
              onChange={handleChangeSearch}
              variant="outlined"
              style={{ width: "49%" }}
            />
            <Box display={"flex"} width="70%" paddingLeft={"15px"}>
              <FormControl
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyItems: "flex-start",
                  width: "100%",
                  marginBottom: "10px",
                  flexDirection: "row",
                }}
              >
                <TextField
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Petani"
                  required
                  size="small"
                  error={false}
                  name="farmerId"
                  onChange={handleChangeSearch}
                  value={searchData.farmerId}
                  fullWidth
                  variant="outlined"
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        onScroll: loadMore(1),
                      },
                      style: {
                        height: "300px",
                      },
                    },
                  }}
                  style={{
                    maxWidth: "400px",
                    background: "white",
                    marginRight: "10px",
                  }}
                >
                  {farmer.docs.length > 0 ? (
                    farmer.docs.map((data, index) => (
                      <MenuItem value={data._id} key={index}>
                        {data.fullName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="">Data kosong</MenuItem>
                  )}
                </TextField>
              </FormControl>
              <Box marginX="15px">
                <Button variant="contained" type="submit">
                  Cari
                </Button>
              </Box>
            </Box>
          </Box>
        </Card>
      </form>

      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
        >
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            NOTA PETANI
          </Typography>
          <table
            style={{
              width: "100%",
              maxHeight: "750px",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {purchaseOrderFarmer.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {purchaseOrder.length > 0 &&
                purchaseOrder.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "20px" }}
                      >
                        <Box
                          display={"flex"}
                          alignItems="center"
                          justifyContent={"center"}
                        >
                          <Checkbox {...label} onChange={handleCheckPO(item)} />
                        </Box>
                      </td>

                      <td className={styles.tableCell}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent={"center"}
                        >
                          {item.purchaseOrderCode}
                        </Box>
                      </td>

                      <td className={styles.tableCell}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent={"center"}
                        >
                          {item.farmerId.fullName}
                        </Box>
                      </td>

                      <td className={styles.tableCell}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent={"center"}
                        >
                          {item.totalPrices.toLocaleString("id", {
                            style: "currency",
                            currency: "IDR",
                          })}
                        </Box>
                      </td>

                      <td className={styles.tableCell}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent={"center"}
                        >
                          {item.status}
                        </Box>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </form>
      </Card>

      <Card className={styles.headerClass}>
        <Box
          display="flex"
          width={"100%"}
          justifyContent="flex-start"
          alignItems="center"
          gap={"20px"}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
              width: "50%",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="200px"
            >
              TOTAL NOTA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalNota"
              value={showedData.totalNota.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "350px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
              width: "50%",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="200px"
            >
              HUTANG PETANI
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="farmerDebt"
              value={showedData.farmerDebt.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "350px",
                marginRight: "10px",
              }}
            />
          </FormControl>
        </Box>

        <Box
          display="flex"
          width={"100%"}
          justifyContent="flex-start"
          alignItems="center"
          gap={"20px"}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
              width: "50%",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="200px"
            >
              TOTAL HUTANG PLASTIK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPrice"
              value={showedData.farmerDebtPlastic.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "350px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <Box display="flex" width="50%">
            <Typography width={"200px"}>GRADE PETANI </Typography>
            <Typography width={"150px"}>A</Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          width={"100%"}
          justifyContent="flex-start"
          alignItems="center"
          gap={"20px"}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
              width: "50%",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="200px"
            >
              TOTAL PEMBAYARAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPembayaranNota"
              value={totalPembayaranNota.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "350px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
              width: "50%",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="200px"
              paddingRight="10px"
            >
              HUTANG PETANI DIBAYARKAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: (
                  <InputAdornment position="start">Rp. </InputAdornment>
                ),
              }}
              error={false}
              name="paidFarmerDebt"
              onChange={handleChangeShowedData}
              value={showedData.paidFarmerDebt}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "350px",
                marginRight: "10px",
              }}
            />
          </FormControl>
        </Box>
        <Box
          display="flex"
          width={"100%"}
          justifyContent="flex-start"
          alignItems="center"
          gap={"20px"}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
              width: "50%",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="200px"
            >
              BONUS
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: (
                  <InputAdornment position="start">Rp. </InputAdornment>
                ),
              }}
              error={false}
              name="bonus"
              onChange={handleChangeShowedData}
              value={showedData.bonus}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "350px",
                marginRight: "10px",
              }}
            />
          </FormControl>
        </Box>

        <div className={styles.footerButton}>
          <Button
            variant="contained"
            type="button"
            onClick={() => handleSubmitAll()}
          >
            SUBMIT
          </Button>
          <Button
            variant="contained"
            color="error"
            style={{ marginLeft: "10px" }}
            onClick={() => navigate("/admin/keuangan/pembayaran-nota")}
          >
            KEMBALI
          </Button>
        </div>
      </Card>
    </Grid>
  );
}
